import { ECHARTSCOLOR } from '@intelligence/utils/echartsConst';

/**
 * 饼状图颜色序列
 */
export const PIE_CHART_COLORS = ECHARTSCOLOR;

/**
 * 饼状图内外半径
 */
export const PIE_RADIUS: [number, number] = [55, 95];

/**
 * 饼状图圆心位置
 */
export const PIE_CENTER: [string, string] = ['50%', '50%'];

/**
 * 扇区边框圆角
 */
export const PIE_BORDER_RADIUS = 5;

/**
 * 扇区边框宽度
 */
export const PIE_BORDER_WIDTH = 1;

/**
 * 扇区边框颜色
 */
export const PIE_BORDER_COLOR = '#fff';

/**
 * 最小扇区角度
 */
export const PIE_MIN_ANGLE = 10;

/**
 * 标签引导线长度
 */
export const PIE_LABEL_LINE_LENGTH = 10;

/**
 * 图例位置（底部）
 */
export const PIE_LEGEND_BOTTOM = 0;

/**
 * 图例间距
 */
export const PIE_LEGEND_ITEM_GAP = 18;

/**
 * 饼状图静态配置
 */
export const PIE_CHART_STATIC_OPTION: any = {
  color: PIE_CHART_COLORS,
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'item',
    padding: 0,
    borderWidth: 0,
    backgroundColor: 'rgba(255, 255, 255, 0)',
    confine: true,
    hideDelay: 200,
    triggerOn: 'mousemove',
  },
  legend: {
    type: 'scroll',
    orient: 'horizontal',
    pageIconColor: '#000',
    selectedMode: true,
    pageIconSize: 12,
    pageTextStyle: {
      color: '#000',
    },
    show: true,
    icon: 'circle',
    itemWidth: 20,
    itemHeight: 10,
    bottom: PIE_LEGEND_BOTTOM,
    left: 'center',
    itemGap: PIE_LEGEND_ITEM_GAP,
    textStyle: {
      padding: [0, 0, 0, -7],
      rich: {
        normalName: {
          color: '#888888',
          fontSize: 12,
        },
        highlightName: {
          color: '#262832',
          fontSize: 12,
          fontWeight: 'bold',
        },
      },
    },
  },
  series: [],
};
